var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFillheart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3497 17.3072C10.5897 17.9972 9.41967 17.9972 8.65967 17.2972L8.54967 17.1972C3.29967 12.4472 -0.130335 9.33717 -0.000335195 5.45717C0.0596648 3.75717 0.929665 2.12717 2.33966 1.16717C4.97966 -0.632832 8.23967 0.207168 9.99967 2.26717C11.7597 0.207168 15.0197 -0.642832 17.6597 1.16717C19.0697 2.12717 19.9397 3.75717 19.9997 5.45717C20.1397 9.33717 16.6997 12.4472 11.4497 17.2172L11.3497 17.3072Z",
    fill: "#F04D1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillheart);
export default __webpack_public_path__ + "static/media/fill.heart.73db76512f31d23f633e233d4066b0a9.svg";
export { ForwardRef as ReactComponent };